let _openExHistory = null;
export function openExHistory(name) { if (_openExHistory) _openExHistory(name); }
export function setOpenExHistory(fn) { _openExHistory = fn; }
